const Director = 'Director'
const Manager = 'Manager'
const Analyst = 'Analyst'
const Financial = "Financial"
const SalesExecutive = 'SalesExecutive'

const employeeRegisterRoutes = [
  {
    path: '/employees/create',
    name: 'CreateEmployee',
    meta: { 
      auth: true,
      roles: [Director],
    },
    component: () => import('@/_backoffice/_registrations/components/employee/CreateEmployee.vue')
  },
  {
    path: '/employees',
    name: 'EmployeeList',
    meta: { 
      auth: true,
      roles: [Director],
    },
    component: () => import('@/_backoffice/_registrations/pages/Employees.vue'),
    children:[
      {
        path: ":id",
        name: "ShowEmployee",
        meta:{
          auth: true,
          roles: [Director],
        },
        component: () => import("@/_backoffice/_registrations/components/employee/ShowEmployee.vue"),
      }
    ]
  },


]


export default employeeRegisterRoutes
